import type { User } from 'api/data.types'
import { PaymentStatus } from '__gql-generated__/types'

const canRenewFamilyPaying = (user: User): boolean => {
  const { reader } = user

  if (reader?.paymentStatus) {
    return reader.paymentStatus === PaymentStatus.CanRenew
  }

  return false
}

export default canRenewFamilyPaying
